import { useState } from "react";

import "../Styles/Card.css";
import { HeartIcon } from "./icons/HeartIcon";
import { likePost, unlikePost } from "../Services/FeedService";

/**
 * Hjärtat på ett flödeskort.
 *
 * Egen komponent för att båda korttyperna ska bete sig likadant. Det
 * mesta i flödet är venue-inlägg — de skapas av igenkänningarna, inte av
 * någon som postar — och de saknade knappen helt, så på ett verkligt
 * flöde gick det knappt att gilla något alls.
 *
 * Optimistisk: hjärtat fylls direkt och rullas tillbaka om anropet
 * fallerar. Servern svarar med det färska antalet, så två snabba klick
 * inte lämnar siffran ur takt.
 */
type Props = {
  postId: string;
  likes: number;
  likedByMe?: boolean;
};

export default function LikeButton({ postId, likes, likedByMe }: Props) {
  const [liked, setLiked] = useState(Boolean(likedByMe));
  const [count, setCount] = useState(likes);
  const [pending, setPending] = useState(false);

  const toggle = async () => {
    if (pending) return;

    const next = !liked;
    setLiked(next);
    setCount((n) => Math.max(0, n + (next ? 1 : -1)));
    setPending(true);

    try {
      const res = next ? await likePost(postId) : await unlikePost(postId);
      setLiked(res.liked);
      setCount(res.likes);
    } catch (e) {
      console.error("like failed", e);
      setLiked(!next);
      setCount((n) => Math.max(0, n + (next ? -1 : 1)));
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="interact-item like-item">
      <button
        className={`likeButton ${liked ? "liked" : ""}`}
        onClick={toggle}
        aria-pressed={liked}
        aria-label={liked ? "Remove like" : "Like"}
      >
        <HeartIcon className="heart-svg" size={18} />
      </button>
      <span className="text-damp">{count}</span>
    </div>
  );
}
